export const STORAGE_SESSION_ACTIVE = "sessionActive";
export const STORAGE_THEME = "theme";
export const STORAGE_GEO_CONSENT = "geo_consent";
